import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

import { computed } from "vue";


export default {
  __name: 'BaseModal',
  props: {
	show: { type: Boolean, default: false },
	title: { type: String, default: "" },
	size: { type: String, default: "md" },
	modalId: { type: String, default: "modal" },
},
  emits: ["close"],
  setup(__props) {

const props = __props;



const modalSize = computed(() => ({ sm: "modal-sm", md: "", lg: "modal-lg", xl: "modal-xl" }[props.size] || ""));

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal base-modal fade", { show: __props.show }]),
    style: _normalizeStyle({ display: __props.show ? 'block' : 'none' }),
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": `${__props.modalId}Label`,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog", modalSize.value]),
      role: "document"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", {
            id: `${__props.modalId}Label`,
            class: "modal-title"
          }, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
            ])
          ], 8 /* PROPS */, _hoisted_4),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close')))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "body")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "footer")
        ])
      ])
    ], 2 /* CLASS */)
  ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
}
}

}